import { Component as PComponent } from '~preact';
import PropTypes from "prop-types";
import { StoreContext } from "../StoreProvider";

/**
 * A public higher-order component to access the imperative API
 */
export const withStoreContext = (Component, ContextOverride) => {
	class HOC extends PComponent {
		render({context, ...props}) {
			const Context = context || ContextOverride || StoreContext;

			return (
				<Context.Consumer>
					{storeContext => (
						<Component
							storeContext={storeContext}
							{...props}
						/>
					)}
				</Context.Consumer>
			);
		}

		static get displayName() {
			return "withStoreContext(" + (Component.displayName || Component.name) + ")"
		}

		static get wrappedComponent() {
			return Component;
		}

		static get propTypes() {
			return {
				context: PropTypes.object,
			}
		}
	}

	return HOC;
};

export default withStoreContext;
